<template>
    <div class="col-5 heading-margin heading-col d-md-block d-none" >
        
        <div class="row align-items-center flex-lg-nowrap m-0 p-xl-0 p-0 pl-5" v-show="routeBreadcrumb != 'Dashboard'">
            <h4 class="navbar-heading">{{ currentRouteName }}</h4>
            <div class="navbar-sub-heading">
              <a href="/" style="margin-top: -3px;">
                <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.10302 0.473538C6.91735 0.298002 6.67153 0.200195 6.41602 0.200195C6.16051 0.200195 5.91469 0.298002 5.72902 0.473538L0.885016 5.05154C0.736698 5.19189 0.618598 5.36105 0.537952 5.54865C0.457307 5.73625 0.415814 5.93834 0.416016 6.14254V11.7125C0.416281 12.1102 0.574434 12.4915 0.85571 12.7726C1.13699 13.0536 1.51836 13.2115 1.91602 13.2115H3.41602C3.81384 13.2115 4.19537 13.0535 4.47668 12.7722C4.75798 12.4909 4.91602 12.1094 4.91602 11.7115V9.21154C4.91602 9.07893 4.9687 8.95175 5.06246 8.85798C5.15623 8.76422 5.28341 8.71154 5.41602 8.71154H7.41602C7.54862 8.71154 7.6758 8.76422 7.76957 8.85798C7.86334 8.95175 7.91602 9.07893 7.91602 9.21154V11.7115C7.91602 12.1094 8.07405 12.4909 8.35536 12.7722C8.63666 13.0535 9.01819 13.2115 9.41602 13.2115H10.916C11.3138 13.2115 11.6954 13.0535 11.9767 12.7722C12.258 12.4909 12.416 12.1094 12.416 11.7115V6.14154C12.416 5.93743 12.3742 5.73549 12.2934 5.54807C12.2126 5.36065 12.0944 5.19169 11.946 5.05154L7.10302 0.471538V0.473538Z"
                    fill="#48A6A6" />
                </svg>
              </a>
              <span style="margin: -3px 12px 0 12px;">
                <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.227539 1.79558L1.27235 0.750765L6.22754 5.70595L1.27235 10.6611L0.227539 9.61632L4.13791 5.70595L0.227539 1.79558Z" fill="#9A9AB0" />
                </svg>
              </span>
              <p class="navbar-paragraph">Dashboard</p> 
              <span style="margin: -3px 12px 0 12px;">
                <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.227539 1.79558L1.27235 0.750765L6.22754 5.70595L1.27235 10.6611L0.227539 9.61632L4.13791 5.70595L0.227539 1.79558Z" fill="#9A9AB0" />
                </svg>
              </span>
              <p  class="navbar-paragraph">{{ currentRouteBreadcrumb }}</p>
            </div>
      </div>
    </div>    
</template>

<script>
export default {
    data: function () {
      return {
        routeBreadcrumb:'',
        routeName:'',
      };
    },
    computed: {
      currentRouteBreadcrumb() {
          // console.log("route",this.$route);
          if((typeof this.$route.matched[2] === 'undefined'|| this.$route.matched[2].meta['breadcrumb'] == null) && typeof this.$route.matched[1] !== 'undefined'){
              return this.routeBreadcrumb = this.$route.matched[1].meta['breadcrumb'] ;
          }else if(typeof this.$route.matched[1] === 'undefined'){
              return this.routeBreadcrumb = this.$route.matched[0].meta['breadcrumb'];
          }else {
              return this.routeBreadcrumb = this.$route.matched[2].meta['breadcrumb'];
          }
          // return this.$route.name;
      },
      currentRouteName() {
          if((typeof this.$route.matched[2] === 'undefined'|| this.$route.matched[2].meta['name'] == null) && typeof this.$route.matched[1] !== 'undefined'){
              return this.routeName = this.$route.matched[1].meta['name'] ;
          }else if(typeof this.$route.matched[1] === 'undefined'){
              return this.routeName = this.$route.matched[0].meta['name'];
          }else {
              return this.routeName = this.$route.matched[2].meta['name'];
          }
          // return this.$route.name;
      }
  }
}
</script>
<style scoped>
.heading-margin{
  padding-top: 22px !important;
  margin-left:-20px;
}
.navbar-sub-heading{
  display: flex;
  padding-top: 4px;
  margin-left: 5%;
}
.breadcrumb-item{
  background-color:white !important;
}
.navbar-paragraph{
  color: #9A9AB0 !important;
  font-size: 14px;
}
.navbar-heading{
  color: #0C1726;
  font-weight: bold;
  font-size: 24px;
}
@media (min-width: 320px) and (max-width:680px){
  .heading-col{
    /* display: none; */
  }
}
</style>